var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00036 1C4.13379 1 1 4.13379 1 7.99961C0.999904 8.91894 1.18091 9.82928 1.53268 10.6786C1.88444 11.528 2.40008 12.2998 3.05015 12.9498C3.70021 13.5999 4.47196 14.1155 5.32133 14.4673C6.17069 14.819 7.08104 15.0001 8.00036 15C11.8655 15 15 11.8662 15 7.99961C15 4.13379 11.8655 1 8.00036 1ZM8.65366 3.52715C9.33613 3.52715 9.53664 3.92307 9.53664 4.37585C9.53664 4.94093 9.08458 5.46371 8.31243 5.46371C7.66642 5.46371 7.35873 5.13925 7.37769 4.60188C7.37769 4.1491 7.75611 3.52715 8.65366 3.52715ZM6.90521 12.1921C6.43857 12.1921 6.09807 11.9085 6.42399 10.6653L6.95844 8.45969C7.05104 8.10679 7.06635 7.96534 6.95844 7.96534C6.81918 7.96534 6.21327 8.20887 5.856 8.44948L5.6234 8.06815C6.7572 7.12102 8.06088 6.56542 8.61866 6.56542C9.08531 6.56542 9.16259 7.11664 8.93 7.96534L8.31754 10.284C8.2089 10.6937 8.25556 10.8352 8.3642 10.8352C8.50419 10.8352 8.96209 10.666 9.41269 10.3109L9.67663 10.6653C8.57346 11.7677 7.37113 12.1921 6.90521 12.1921Z",
    fill: "#2574FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBlue);
export default __webpack_public_path__ + "static/media/infoBlue.aa8d79cb4aba7d794df9b052a875a760.svg";
export { ForwardRef as ReactComponent };